import React, { useEffect, useState } from "react";
import logo from "../assets/images/logo.png";
import mintTea from "../assets/images/undraw_mint_tea_-7-su0.svg";
import btaCircleCourt from "../assets/images/bta_images_circle.png";
import {
  LockOutlined,
  UserOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Steps,
  Button,
  message,
  Form,
  Input,
  Image,
  Carousel,
  Card,
  Divider,
  Select,
  Spin,
  Alert,
} from "antd";
import { SearchOutlined, RightOutlined } from "@ant-design/icons";
import authService from "../api/auth.service";
import { useNavigate } from "react-router-dom";
import commonService from "../api/common.service";
import { SUCCESS_STATUS } from "../utility/Constants";

const { Option } = Select;
const cardStyle = {
  width: "auto",
  height: "auto",
  borderRadius: "16px",
  marginRight: "0px",
  boxShadow:
    "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
};
const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 16,
      color: "white",
      marginLeft: "8px",
    }}
    spin
  />
);

const Login = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [yearlist, setYearlist] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormError, setIsFormError] = useState(false);
  const [formErrorMessage, setFormErrorMessage] = useState("");

  const onFinish = async (values) => {
    setIsLoading(true);
    console.log('Received values of form: ', values);
    const auth_response = await authService.login(
      values.username,
      values.password,
      values.yearID
    );

    if (auth_response.status === SUCCESS_STATUS) {
      //console.log(auth_response);
      localStorage.setItem("user", JSON.stringify(auth_response));
      navigate("/Dashboard");
      setIsLoading(false);
      window.location.reload();
    } else {
      // console.log(auth_response);
      setIsLoading(false);
      setIsFormError(true);
      setFormErrorMessage(auth_response.msg);
    }
  };

  useEffect(() => {
    commonService.getYearList().then((res) => {
      if (res.data.status === SUCCESS_STATUS) {
        setYearlist(res.data.result);
      }
    });
  }, []);

  return (
    <div>
      <div className="login-first-step" style={{ padding: "2rem" }}>
        <div className="login-first-step-wrapper">
          <Card title="" bordered={false} style={cardStyle}>
            <Row
              className="login-first-step-row"
              style={{ background: "white", borderRadius: "16px" }}
            >
              <Col
                className="login-first-step-block-1"
                xs={24}
                xl={14}
                style={{ paddingTop: "3rem", paddingBottom: "3rem" }}
              >
                <div style={{ width: "80%", margin: "0 auto" }}>
                  <Image width={150} src={logo} preview={false} />
                  <h1 className="login-first-step-block-1-title">
                    <span>WELCOME TO </span>
                    <span style={{ color: "#149100" }}>
                      Bengal Tennis Association{" "}
                    </span>
                  </h1>

                  {/* <Divider plain>
           Verify your client code before login
         </Divider> */}

                  <Divider />

                  <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    autoComplete="off"
                  >
                    <Row>
                      <Col xs={24} xl={12}>
                        <Form.Item
                          name="username"
                          label="Username"
                          rules={[
                            {
                              required: true,
                              message: "Username is required",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Username"
                            addonBefore={<UserOutlined />}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={12}>
                        <Form.Item
                          name="password"
                          label="Password"
                          rules={[
                            {
                              required: true,
                              message: "Password is required",
                            },
                          ]}
                        >
                          <Input.Password
                            placeholder="Password"
                            iconRender={(visible) =>
                              visible ? (
                                <EyeTwoTone />
                              ) : (
                                <EyeInvisibleOutlined />
                              )
                            }
                            autoComplete="off"
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={24} xl={12}>
                        <Form.Item
                          name="yearID"
                          label="Year"
                          rules={[
                            {
                              required: true,
                              message: "Year is required",
                            },
                          ]}
                        >
                          <Select className="text-left" defaultValue="0">
                            <Option key="0" value="0">
                              Select Year
                            </Option>
                            {yearlist.length > 0
                              ? yearlist.map((year_data) => (
                                <Option
                                  key={year_data.year_id}
                                  value={year_data.year_id}
                                >
                                  {year_data.year}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={12}>
                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            shape="round"
                            style={{
                              float: "left",
                              marginLeft: "2rem",
                              marginTop: "1.9rem",
                            }}
                            className="theme-button"
                          >
                            Continue
                            {isLoading && <Spin indicator={antIcon} />}
                            {!isLoading && <RightOutlined />}
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                  {isFormError && (
                    <Alert
                      message={formErrorMessage}
                      type="error"
                      showIcon
                      className="text-left"
                    />
                  )}
                </div>
              </Col>
              <Col
                xs={24}
                xl={10}
                style={{ background: "#06bf00", paddingTop: "1rem", borderRadius: "0 16px 16px 0" }}
                className="login-first-step-block-2"
                align="center"
              >
                <div className="">
                  <Image width={200} src={btaCircleCourt} preview={false} />
                  <h3>Our Mission </h3>
                  <Divider />
                  <p style={{textAlign: "justify"}}>
                    To Provide Tennis Service To The Community At Large.<br/> 
                    To Reach Out to the Vast Reservoir Of Talent And Exploit its
                    true potential with an aim to produce Champions.
                  </p>
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Login;
